import React, { useState } from "react";
import emailjs from "@emailjs/browser";

// 🔥 Firebase
import { db } from "../../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// use the working IDs
const SERVICE_ID = "service_8zdzcrm";
const TEMPLATE_ID = "template_ddhelxl";
const PUBLIC_KEY = "0Fjv2nPHJp_vBoP80";

const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    if (!form.name.trim()) return false;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return false;
    if (!form.subject.trim()) return false;
    if (!form.message.trim()) return false;
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setStatus("error");
      return;
    }

    setSending(true);
    setStatus(null);

    try {
      // 1️⃣ Store message in Firestore
      await addDoc(collection(db, "contactMessagesAspirantLanding"), {
        name: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
        createdAt: serverTimestamp(),
        status: "new",
        source: "landing_contact_form", // optional, helps you know where it came from
      });

      // 2️⃣ Send email via EmailJS (same as before)
      const templateParams = {
        from_name: form.name,
        from_email: form.email,
        subject: form.subject,
        message: form.message,
      };

      const res = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
      );

      if (res.status === 200) {
        setStatus("success");
        setForm({ name: "", email: "", subject: "", message: "" });
      } else {
        console.error("EmailJS non-200 response:", res);
        setStatus("error");
      }
    } catch (err) {
      console.error("EmailJS / Firestore error:", err);
      setStatus("error");
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="bg-[#f8fafc] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 py-12">
        <h2 className="text-2xl md:text-3xl font-bold text-[#3C0F6C] mb-6">
          Get in touch
        </h2>
        <form
          onSubmit={onSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white p-6 rounded-2xl shadow border border-gray-100"
        >
          <input
            name="name"
            value={form.name}
            onChange={onChange}
            placeholder="Name"
            className="px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={onChange}
            placeholder="Email"
            className="px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <input
            name="subject"
            value={form.subject}
            onChange={onChange}
            placeholder="Subject"
            className="md:col-span-2 px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <textarea
            name="message"
            value={form.message}
            onChange={onChange}
            placeholder="Message"
            rows={5}
            className="md:col-span-2 px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <div className="md:col-span-2 flex items-center gap-4">
            <button
              type="submit"
              disabled={sending}
              className="px-6 py-3 rounded-xl bg-[#3C0F6C] text-white font-semibold disabled:opacity-60"
            >
              {sending ? "Sending…" : "Send Message"}
            </button>
            {status === "success" && (
              <span className="text-green-600 text-sm">
                ✅ Message sent successfully!
              </span>
            )}
            {status === "error" && (
              <span className="text-red-600 text-sm">
                ❌ Something went wrong.
              </span>
            )}
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
